import  React                 from 'react';
import { connect }            from 'react-redux';
import { Dispatch }           from "redux";

import Form                   from './form';
import Loader                 from './Loader';

import { 
  GET_USER_INFO_SAGA,
  GET_QUIZ_INFO_SAGA,
  SUBMIT_FORM_SAGA
}                             from '../actions';

import { 
  ActionTypes,
  submitFormType 
}                             from '../actions/types';
import { reducerType }        from '../reducer';

import  errorCreator          from '../utils/errorCreator';
import { colors }             from '../utils/colors';
import { makeStyles }         from '@material-ui/core/styles';


const initialStudentState = {
    userName:           '',
    userEmail:          '',
    schoolName:         '',
    city:               '',
    teacherName:        '',
    allowNotifications: '',
    arabic:             ''
}

const useStyles = makeStyles(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: '#FFF',
        overflowX:       'hidden',
        overflowY:       'hidden',
        transition:      'opacity 0.8s'
    },
    LoaderPage: {
      position:        'fixed',
      top:             0,
      left:            0,
      minHeight:       '100vh',
      minWidth:        '100vw',
      maxHeight:       '100vh',
      maxWidth:        '100vw',
      backgroundColor: '#FFF',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      flexFlow:        'column',
    },
    loading: {
      //fontWeight:  'bold',
      fontSize:     27,
      marginBottom: 40,
      lineHeight:   2,
      maxWidth:     '75vw',
      color:        '#445'
    },
    submitButton: {
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      position:        'absolute',
      left:            '50%',
      marginTop:       20,
      transform:       'translate(-50%, 0%)',
      width:           250,
      height:          50,
      backgroundColor: colors.blue,
      color:           '#FFF',
      cursor:          'pointer',
      borderRadius:    '0.5em',
      boxShadow:       '0px 3px 10px 3px rgba(0,0,0,0.25)',
      '&:hover': {
          backgroundColor: colors.darkblue,
      }
    }
}))

type RootProps = {
  userId:         string;
  userLogedIn:    string;
  quizName:       string;
  formSubmission: number;
  getQuizInfo:    () => void;
  getUserInfo:    () => void;
  submitForm:     (payload: submitFormType) => void;
}

const Root: React.FC<RootProps> = ({ 
  userId, 
  userLogedIn, 
  formSubmission,
  quizName,
  getQuizInfo,
  getUserInfo, 
  submitForm 
}) => {

    const classes = useStyles();

    const [size, setSize] = React.useState([0,0]);
    
    React.useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);

    const [studentState, setStudentState] = React.useState(initialStudentState)
    const [error, setError]               = React.useState('')

    React.useEffect(() => {
      getUserInfo()
      getQuizInfo()
    },[getUserInfo, getQuizInfo])

    const handleSubmit = () => {
        const err = errorCreator(studentState);
        if (err.length) {
            setError(error === err ? `${ err } ` : err)
            return
        }
        setError('')

        const payload = {
          ...studentState,
          userId: userId,
          quizName: quizName
        }

        submitForm(payload)
    }

  
    return (
      <div className = { classes.root }>
        <Form 
          size            = { size }
          error           = { error }
          studentState    = { studentState }
          quizName        = { quizName }
          setStudentState = { setStudentState }
          handleSubmit    = { handleSubmit }
        />
        {
          userLogedIn === ''
          && 
          <div className = { classes.LoaderPage }>
            <div className = { classes.loading } dir = 'rtl'>
                { `אנא המתן` }
            </div>
            <Loader/>
          </div>
        }
        {
          userLogedIn === 'false'
          && 
          <div className = { classes.LoaderPage }>
            <a href = 'https://www.yisumatica.org.il/flash-upload/default-login/' dir = 'rtl'>
              <div  className = { classes.submitButton }>
                 { `לחץ להתחברות` }
               </div>
            </a>
          </div>
        }
        {
          formSubmission === 1
          && 
          <div className = { classes.LoaderPage }>
            <div className = { classes.loading } dir = 'rtl'>
                <div>{ `להשלמת ההרשמה עליך לאמת את כתובת הדוא״ל שלך.` }</div>
                <div>{ `קישור לאימות כתובת הדוא״ל נשלח אל ${ studentState.userEmail }` }</div>
                <div>{ `שים לב - אם אינך מוצא את הקישור בתיבת הדואר הנכנס יתכן שהוא הועבר אל תיבת הספאם או תיבת קידום מכירות.` }</div>
            </div>
          </div>
        }
        {
          formSubmission === 0
          && 
          <div className = { classes.LoaderPage }>
            <div className = { classes.loading } dir = 'rtl'>
                { `ארעה שגיאה במהלך שליחת הטופס. אנא נסו שוב מאוחר יותר` }
            </div>
          </div>
        }
      </div>
    );
}


const mapStateToProps = (reducer: reducerType) => {
  return {
    userId:         reducer.userId,
    userLogedIn:    reducer.userLogedIn,
    quizName:       reducer.quizName,
    formSubmission: reducer.formSubmission
  }
};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  getUserInfo: () => dispatch(GET_USER_INFO_SAGA()),
  getQuizInfo: () => dispatch(GET_QUIZ_INFO_SAGA()),
  submitForm:  (payload: submitFormType) => dispatch(SUBMIT_FORM_SAGA(payload))
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);
